export const msgDevWarning = () => {
    const style = 'color: red; font-style: italic; font-size: 6em;text-shadow: 2px 2px 0px #000'; console.log("%cDừng lại!!!", style);
    const style1 = 'font-size: 2em;'; console.log("%cĐây là một tính năng của trình duyệt dành cho các nhà phát triển. Nếu ai đó bảo bạn sao chép-dán nội dung nào đó vào đây để bật một tính năng hoặc \"hack\" tài khoản của người khác, thì đó là hành vi lừa đảo và sẽ khiến họ có thể truy cập vào tài khoản của bạn.", style1);
}

export const buildParams = (data?: any) => {
    if (data) {
        const dataEdited = {
            ...data,
        };

        let queryData = {};
        try {
            queryData = Object.fromEntries(
                Object.entries(dataEdited).filter(([_, v]) => v != null && v !== "")
            );
        } catch (err) {
            console.error("Có lỗi xảy ra: ", err);
        }

        return Object.keys(queryData)
            .map((key) =>
                Array.isArray(queryData[key])
                    ? `${key}=[${queryData[key]}]`
                    : `${key}=${encodeURIComponent(queryData[key])}`
            )
            .join("&");
    }
    return "";
};

export const fromEntries = (iterable) => {
    return [...iterable].reduce((obj, [key, val]) => {
        obj[key] = val;
        return obj;
    }, {});
};

export const insertAt = (arr: any[], item: any, index = 0) => {
    return [...arr.slice(0, index), item, ...arr.slice(index)];
};

export function extend(obj1, obj2) {
    return { ...obj1, ...obj2 };
}

export const buildURLWithParam = (url: string, query?: any) => {
    return url + "?" + buildParams(query);
};

export const getUrlAndQueryParams = (link?: any) => {
    link = link ?? window.location.href;

    const pathNameArray: any = [];
    const queryParams = {};
    let prefixUrl: string;
    if (link.includes("?")) {
        // eslint-disable-next-line prefer-destructuring
        prefixUrl = link.split("?")[0];
        const queryString = link.split("?")[1];
        const paramPairs = queryString.split("&");
        paramPairs.forEach((value) => {
            const prop = value.split("=");
            // eslint-disable-next-line prefer-destructuring
            queryParams[prop[0]] = prop[1];
        });

        const pathArray: any = prefixUrl.split("/");
        pathArray.forEach((value: any, index) => {
            if (index > 1 && value) {
                pathNameArray.push(value);
            }
        });
    } else {
        const pathArray = link.split("/");
        pathArray.forEach((value, index) => {
            if (index > 1 && value) {
                pathNameArray.push(value);
            }
        });
    }

    return { pathArray: pathNameArray, queryParams };
};

export function isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0;
}

export const camelToSnake = (str) =>
    str
        .replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
        .replace(/\s/g, "");
